import { createFeatureContext } from 'src/libs/FeatureConfig';
export const { FeatureConfigProvider, useFeatureConfig } = createFeatureContext(
  [
    {
      name: 'verified-workplace',
    },
  ],
);
